import axios from "axios";
import { API_ROOT } from "../services/api";
import { ADMIN_GET_ALL_USER, ADMIN_GET_USER_AGENDA,ADMIN_GET_AGENDA_COUNSELLOR,ADMIN_GET_USER_DIARY,ADMIN_GET_USER_PRACTICE ,ADMIN_GET_USER_DETAIL,ADMIN_GET_USER_PROFILE, ADMIN_GET_ALL_USER_APPLY,ADMIN_GET_ROOMS} from "./actionTypes";
import { get } from "lodash";

export const getUserAll = () => (dispatch) => {
  dispatch({ type: ADMIN_GET_ALL_USER.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/userlist`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_ALL_USER.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_ALL_USER.FAILURE, payload: error.message });
    });
};

export const getUserAllApply = () => (dispatch) => {
  dispatch({ type: ADMIN_GET_ALL_USER_APPLY.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/userapplylist`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_ALL_USER_APPLY.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_ALL_USER_APPLY.FAILURE, payload: error.message });
    });
};

export const getUserProfile = () => (dispatch) => {
  dispatch({ type: ADMIN_GET_USER_DETAIL.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/user/Profile`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_USER_DETAIL.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_USER_DETAIL.FAILURE, payload: error.message });
    });
};


export const deleteUser = (uid) => {
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/delete/${uid}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const approveUser = (uid, isApprove) => {
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/approve/${uid}/${isApprove}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const getUserAgenda = (telephoneNo) => (dispatch) => {
  dispatch({ type: ADMIN_GET_USER_AGENDA.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/agenda/get-by-phone/${telephoneNo}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_USER_AGENDA.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_USER_AGENDA.FAILURE, payload: error.message });
    });
};

export const getAgendaOfCounsellor = (counsellor_uid) => (dispatch) => {
  dispatch({ type: ADMIN_GET_AGENDA_COUNSELLOR.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/agenda/get-by-uid/${counsellor_uid}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_AGENDA_COUNSELLOR.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_AGENDA_COUNSELLOR.FAILURE, payload: error.message });
    });
};

export const getUserDiary = (telephoneNo) => (dispatch) => {
  dispatch({ type: ADMIN_GET_USER_DIARY.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/diary/get-by-phone/${telephoneNo}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_USER_DIARY.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_USER_DIARY.FAILURE, payload: error.message });
    });
};

export const getUserPractice = (telephoneNo) => (dispatch) => {
  dispatch({ type: ADMIN_GET_USER_PRACTICE.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/practice/get-by-phone/${telephoneNo}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_USER_PRACTICE.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_USER_PRACTICE.FAILURE, payload: error.message });
    });
};

export const deleteAgenda = (telephoneNo) => {
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/agenda/delete/${telephoneNo}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const createAgenda = (data) => {
  return axios({
    method: "post",
    url: `${API_ROOT}/admin/agenda/create`,
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    }
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const updateAgendaByCounsellor = (data) => {
  return axios({
    method: "post",
    url: `${API_ROOT}/admin/agenda/updateByCounsellor`,
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    }
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const updateAgendaBySupervisor = (data) => {
  return axios({
    method: "post",
    url: `${API_ROOT}/admin/agenda/updateBySupervisor`,
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    }
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const updateNoteApplicationBySupervisor = (data) => {
  return axios({
    method: "post",
    url: `${API_ROOT}/admin/application/updateBySupervisor`,
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    }
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};


export const getRoomAll = () => (dispatch) => {
  dispatch({ type: ADMIN_GET_ROOMS.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/admin/rooms`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_ROOMS.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_ROOMS.FAILURE, payload: error.message });
    });
};

export const addRoom = (data) => {
  return axios({
    method: "post",
    url: `${API_ROOT}/admin/room/add`,
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    }
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const updateRoom = (data) => {
  return axios({
    method: "post",
    url: `${API_ROOT}/admin/room/update`,
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    }
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const removeRoom = (data) => {
  return axios({
    method: "post",
    url: `${API_ROOT}/admin/room/remove`,
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    }
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const getUserProfileByUserId = (uid) => (dispatch) => {
  dispatch({ type: ADMIN_GET_USER_PROFILE.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/user/Profile/${uid}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access-token"),
    },
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_USER_PROFILE.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_USER_PROFILE.FAILURE, payload: error.message });
    });
};
